export const getTrimmedDescription = (description) => {
  if (!description) return "";
  return description.length > 300
    ? `${description.slice(0, 300)}...`
    : description;
};
